import './email-body-control.scss';

import EmailBodyControl from './EmailBodyControl';

export default EmailBodyControl;
